<template>
    <div>
      <Breadcrumb :breadcrumbList="breadcrumbList" />
      <div class="content-header px-0">
        <h1 class="title-I">Editar Aplicação</h1>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="card direct-chat direct-chat-primary employee">
            <div class="card-body">
              <div class="pt-4 pr-4 pb-2 pl-4 bg-white rounded">
                <div class="row mb-2">
                  <div class="col-12">
                    <div class="card direct-chat direct-chat-primary">
                      <div class="card-body custom-card overflow-visible">
                        <div class="p-4 bg-white rounded">
                          <form @submit.prevent="updateApplication" novalidate="true">
                            <div class="row">
                              <TwInput label="Nome da Aplicação" required="true">
                                <input
                                  type="text"
                                  v-model="application.name"
                                  class="form-control"
                                  placeholder="Nome da Aplicação"
                                  id="name"
                                  disabled
                                />
                              </TwInput>
                              <TwInput label="Nível de Acesso" required="true">
                                <select
                                  id="level"
                                  class="form-control"
                                  v-model="application.level"
                                >
                                  <option
                                    v-for="level in levels"
                                    :key="level"
                                    :value="level"
                                  >
                                    {{ level }}
                                  </option>
                                </select>
                              </TwInput>
                              <TwInput label="Grupo" required="true">
                                <select
                                  id="group"
                                  class="form-control"
                                  v-model="application.group"
                                >
                                  <option
                                    v-for="group in groups"
                                    :key="group"
                                    :value="group"
                                  >
                                    {{ group }}
                                  </option>
                                </select>
                              </TwInput>
                              <TwInput label="Senha" required="true">
                                <input
                                  disabled
                                  type="password"
                                  v-model="application.password"
                                  class="form-control"
                                  placeholder="Senha"
                                  id="password"
                                />
                              </TwInput>
                            </div>
                            <div class="row p-1">
                              <button
                                id="updateApplication"
                                type="submit"
                                class="btn btn-primary px-5"
                                :disabled="load"
                              >
                                <i
                                  v-if="load"
                                  class="fas fa-sync-alt fa-spin"
                                ></i>
                                Atualizar
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import TwInput from '../../components/TwInput.vue';
  import Breadcrumb from "../../components/Breadcrumb.vue";
  
  export default {
    name: "AppIDEdit",
    data() {
      return {
        breadcrumbList: [],
        application: {
          name: "",
          level: "",
          group: "",
        },
        levels: ["DASHBOARD", "USER", "USRADMIN"],
      };
    },
    mounted() {
      this.updateList();
      this.$store.dispatch("user/getGroups");
      this.$store.dispatch("applications/getAppId", {
        app_id_name: this.$route.params.appIdName
      })
    },
    watch: {
      appId() {
        this.application = {
          name: this.appId.name,
          level: this.appId.level,
          group: this.appId.group,
        }
      }
    },
    methods: {
      updateList() {
        this.breadcrumbList = this.$route.meta.breadcrumb;
      },
      validateApplication() {
        if (!this.application.name.trim()) {
          window.frontMsg("FRNT_EMPTY_WARNING", { field: "Nome da Aplicação" });
          return false;
        }
        if (!this.application.level) {
          window.frontMsg("FRNT_EMPTY_WARNING", { field: "Nível de Acesso" });
          return false;
        }
        if (!this.application.group) {
          window.frontMsg("FRNT_EMPTY_WARNING", { field: "Grupo" });
          return false;
        }
        return true;
      },
      async updateApplication() {
        if (this.validateApplication()) {
          await this.$store.dispatch("applications/updateAppId", this.application);
          this.$router.push("/applications");
        }
      },
    },
    components: {
      Breadcrumb,
      TwInput,
    },
    computed: {
      load() {
        return this.$store.getters["load"];
      },
      groups() {
        return this.$store.getters["user/groups"].map((group) => group.name);
      },
      appId(){
        return this.$store.getters["applications/app_id"];
      }
    },
  };
  </script>
  